module.exports = __webpack_public_path__ + "static/media/chancejs_logo.ba02c3e5.png";